export default {
  form: {
    preparation_time: {
      label: 'Anna mukautettu aika (minuuttia):',
      placeholder: 'Syötä minuutit',
    },
  },
  buttons: {
    custom: 'Mukautettu',
  },
  feedback: {
    preparation_time_required: 'Valmistusajan on oltava yli 0 minuuttia',
    min_preparation_time: 'Vähintään {{minutes}} minuuttia valmistusaikaa ulkoiselle toimitukselle',
    max_preparation_time: 'Enintään {{minutes}} minuuttia valmistusaikaa',
  },
};
